import EdIcons from './src/index.vue'

/* istanbul ignore next */
EdIcons.install = function (Vue) {
    Vue.component(EdIcons.name, EdIcons)
}

export default EdIcons
